// Copyright (C) 2015 Minted Inc.
// All Rights Reserved
// CTAG:COMMUNITY:CHALLENGES

(function (M, _, $, Backbone) {
  'use strict';

  M.Community = M.Community || {};
  M.Community.View = M.Community.View || {};
  M.Community.View.Challenge = M.Community.View.Challenge || {};
  
  /**
   * @class M.Community.View.Challenge.PollingComponent
   *
   * Description:
   *  Renders polling panels inside the square panel on challenge hub page
   *
   */
  M.Community.View.Challenge.PollingComponent = Backbone.View.extend({
    template: M.Template.Community.Challenge.PollingComponent,
    skipPollText: 'skip this poll',

    initialize: function() {
      M.assert(this.model);
      this.$el = $(this.el);
      this.container = this._createContainerPanel();
      this.initializeParentContainer();
      if (this.options.shouldUsePopupGallery) {
        this._attachClickHandlersForPopupGallery();
      }

    },

    initializeParentContainer: function() {
      this.container.render();
      this.$containerEl = this.container.$el;
    },

    render: function() {
      this._addPollOptionTags();
      this.options.model = this.model;
      var templateHTML = this.template(this.options);
      this.$el.html(templateHTML);
      return this.$el;
    },

    _createContainerPanel: function() {
      var pollPanelOptions = {
        title: this.options.headerText,
        designerStatus: 'created a poll',
        component: this,
        designerName: this.options.designerName,
        designerLocation: this.options.designerLocation,
        designerAvatarUrl: this.options.designerAvatarUrl,
        designerProfilePageUrl: this.options.designerProfilePageUrl,
        actionButtonUrl: this.options.designRatingPageUrl,
        actionButtonText: 'help decide',
        actionButtonInstrAction: "M.GA.TRACK_EVENT_ACTION.GIVE_POLL_FEEDBACK_CLICK",
      };
      return new M.Community.View.Challenge.SquarePanel(pollPanelOptions);
    },

    _addPollOptionTags: function() {
      var that = this;
      this.options.pollOptionTags = [];
      this.model.get('options').each(function(element, i) {
        that.options.pollOptionTags.push(String.fromCharCode(i + 65));
      }, that);
    },

    handlePollClick: function() {
      var that = this;
      if (!M.currentUser.uid) {
        M.Url.RedirectToLogin();
      } else {
        that.renderPollGallery();
      }
    },

    _attachClickHandlersForPopupGallery: function() {
      var that = this;
      // Change the click action for the main button to render the gallery
      var $buttonContainer = this.$containerEl.find('.actionButtonContainer');
      $buttonContainer.find('a').removeAttr('href');
      $buttonContainer.find('button').click(function(e) {
        that.handlePollClick();
      });

      // Change the click action for the poll options to also render the gallery
      this.$el.find('.pollOptionsContainer a').removeAttr('href');
      this.$el.find('.pollOptionsContainer .designImageBox').click(function(e) {
        that.handlePollClick();
      });
    },

    renderPollGallery: function() {
      if (!this.$pollGalleryWidget) {
        this.$pollGalleryWidget = this._createUserResponseWidgetForGallery();
        this.$pollGalleryWidget.fetchDataAndRender();
        this._createDialogForPollGallery(this.$pollGalleryWidget.$el);
      }

      this.$pollGalleryWidget.$el.dialog('open');
    },

    _createUserResponseWidgetForGallery: function() {
      var userInfo = {
        userAvatarUrl: this.options.designerAvatarUrl,
        userProfileUrl: this.options.designerProfilePageUrl,
        userName: this.options.designerName,
        userLocation: this.options.designerLocation
      };
      var modelForCurrentPoll = new M.Community.Model.UserResponseWidget({
        url: this.options.pollGalleryUrlPath,
        itemUrl: this.options.designRatingPageUrl,
        itemName: this.options.designName,
        subtitleText: this.options.challengeTitle,
        userInfo: userInfo,
        pollId: this.model.get('id'),
        designId: this.options.designId,
        urlPaths: this.options.pollUrlPaths,
        responseCount: this.options.pollResponseCount
      });
      var collectionModels = [ modelForCurrentPoll ];
      var collectionOptions = {
        url: this.options.pollGalleryUrlPath
      };
      var collection = new M.Community.Collection.UserResponseWidgetList (
        collectionModels, collectionOptions);
      var userResponseWidget = new M.Community.View.UserResponseWidget({
        headerText: this.options.headerText,
        secondaryHeaderText: "results from the last poll",
        buttonLabel: this.skipPollText,
        collection: collection,
        challengeId: this.options.challengeId,
        challengeTitle: this.options.challengeTitle
      });
      return userResponseWidget;
    },

    _createDialogForPollGallery: function($parentEl) {
      $parentEl.dialog({
        dialogClass: "no-title-with-close flat-white-ui",
        draggable: false,
        width: 1200,
        modal: true,
        autoOpen: false,
        resizable: false,
        position: ['center', 100]
      });
    }

  });
  
})(M, _, $, Backbone);
